import { defineMessages } from 'react-intl';

export const hairAnalyserMessages = defineMessages({
  hairAnalyserTitle: {
    id: 'pd.hairAnalyserTitle',
    defaultMessage: 'Diagnostika vlasů',
  },
  hairAnalyserDescriptionVariant: {
    id: 'pd.hairAnalyserDescriptionVariant',
    defaultMessage: 'Nechte si doporučit péči na míru s {brandName}',
  },
  hairAnalyserRunDiagnostic: {
    id: 'pd.hairAnalyserRunDiagnostic',
    defaultMessage: 'Vyzkoušet',
  },
});
